module.exports = __webpack_public_path__ + "static/media/Saursh.af13da5f.png";